import { inject, Injectable } from '@angular/core';
import { difference } from '@sama/micro-dash';
import { withHistory } from '@sama/rxjs-core';
import { merge, switchMap } from 'rxjs';
import { filter as filterOperator, map } from 'rxjs/operators';
import { ObjectState } from '../../../cross-team-shared/annotation/shared/state/object-state';
import { ShapeState } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { AbstractAnnotationTransientInfoUpdateService } from './abstract-annotation-transient-info-update.service';
import { AnnotationFilteringService } from './annotation-filtering.service';
import { ObjectService } from './object.service';

@Injectable()
export class AnnotationFilterUpdateService extends AbstractAnnotationTransientInfoUpdateService<'isFilteredOut'> {
  protected override transientKey = 'isFilteredOut' as const;

  private objectService = inject(ObjectService);
  private annotationFilteringService = inject(AnnotationFilteringService);

  subscribeToChangesUpdatingFiltering() {
    this.subscribeToChangesUpdatingTransientValue();
  }

  protected override getObjectIdsChanged$() {
    return this.taskWorkspaceStore('task')('id').$.pipe(
      switchMap(() =>
        merge(
          this.getObjectIdsNewlyInOrOutOfScope$(),
          this.objectService.objectIdsWithParentIdChanged$,
        ).pipe(
          map((objectIds) => {
            const objects = this.taskWorkspaceStore.state().objects;
            // fix me if you change this code

            return objectIds.filter((objectId) => objects[objectId]);
          }),
          filterOperator((objectIds) => objectIds.length > 0),
        ),
      ),
    );
  }

  protected override getNewTransientValueForObject(object: ObjectState) {
    return this.annotationFilteringService.calculateIsObjectFilteredOut(object);
  }

  protected override getNewTransientValueForShape(shape: ShapeState) {
    return this.annotationFilteringService.calculateIsShapeFilteredOut(shape);
  }

  private getObjectIdsNewlyInOrOutOfScope$() {
    return this.objectScopingService.getAllObjectIdsInScope$().pipe(
      withHistory(1),
      map(([objectIdsAfter, objectIdsBefore]) =>
        Array.from(
          new Set([
            ...difference(objectIdsAfter, objectIdsBefore ?? []),
            ...difference(objectIdsBefore ?? [], objectIdsAfter),
          ]),
        ),
      ),
    );
  }
}
